/**
 * The mark. A hand as five stacked strokes over a waveform baseline — gesture
 * above, sound below, one shared axis. Inline SVG, currentColor, no image
 * assets; legible at 24px and at 200px.
 */

export function markSvg(size = 28): string {
  return `<svg class="mark" width="${size}" height="${size}" viewBox="0 0 32 32" fill="none"
    role="img" aria-label="Gesture Synth">
    <g stroke="currentColor" stroke-width="1.7" stroke-linecap="round">
      <path d="M7 14V8.5" opacity=".55"/>
      <path d="M11.5 13V5"/>
      <path d="M16 12.6V3.5"/>
      <path d="M20.5 13V6"/>
      <path d="M25 14.2V9.5" opacity=".55"/>
      <path d="M4 21c2.6 0 2.6-5 5.2-5s2.6 8 5.2 8 2.9-6 5.4-6 2.7 3.6 5.2 3.6H28"
        stroke-linejoin="round"/>
    </g>
    <circle cx="16" cy="28.5" r="1.4" fill="currentColor"/>
  </svg>`;
}

export function faviconDataUrl(): string {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <rect width="32" height="32" rx="6" fill="#1E2328"/>
    <g stroke="#5FB3A1" stroke-width="2.2" stroke-linecap="round">
      <path d="M11 13V6"/><path d="M16 12.5V4"/><path d="M21 13V7"/>
      <path d="M6 22c3 0 3-5 6-5s3 8 6 8 3-6 6-6h2"/>
    </g></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}
